import { Drawer as DrawerAnt } from 'antd';
import React, { createContext, useEffect, useMemo, useState } from 'react';
import { Placement2Axis, Size } from '../../types/component.type';
import { Icon } from '../icon/icon.component';
import './drawer.component.scss';

export const DrawerContext = createContext<{
  close: () => void;
  open: () => void;
} | null>(null);

export declare namespace DrawerType {
  type Props = {
    className?: string;
    children?: DrawerType.Data;
    data: React.ReactNode;
    handleEvent?: {
      close?: () => void;
    };
    config?: {
      placement?: Extract<Placement2Axis, 'top' | 'left' | 'right' | 'bottom'>;
      size?: Extract<
        Size,
        | 'xsmall'
        | 'small'
        | 'medium'
        | 'xmedium'
        | 'large'
        | 'xlarge'
        | 'xxlarge'
      >;
      isOpen?: boolean;
    };
  };

  type Data = React.ReactNode;
}

export const Drawer = ({
  className = '',
  children,
  data,
  config: { placement = 'right', size = 'medium', isOpen } = {},
  handleEvent: { close } = {},
}: DrawerType.Props) => {
  const [open, setOpen] = useState(false);

  const orientation = useMemo(
    () => (['right', 'left'].includes(placement) ? 'horizontal' : 'vertical'),
    [placement],
  );

  useEffect(() => {
    setOpen(false);
    close?.();
  }, [location.pathname]);

  useEffect(() => {
    if (isOpen) setOpen(isOpen);
    if (isOpen === false) close?.();
  }, [isOpen]);

  return (
    <DrawerContext.Provider
      value={{
        open: () => setOpen(true),
        close: () => {
          setOpen(false);
          close?.();
        },
      }}
    >
      {children && (
        <div onClick={() => setOpen(true)} className="drawertrigger">
          {children}
        </div>
      )}
      <DrawerAnt
        destroyOnHidden={true}
        rootClassName={`
          drawer
          drawer--${orientation}--${size} 
          ${className}
        `}
        placement={placement}
        size={'default'}
        onClose={() => {
          setOpen(false);
          close?.();
        }}
        open={open}
        extra={
          <div
            className="drawer__close"
            onClick={() => {
              setOpen(false);
              close?.();
            }}
          >
            <Icon
              config={{
                size: 'xxlarge',
                type: 'faXmarkSolid',
                color: 'yang',
              }}
            />
          </div>
        }
      >
        {data}
      </DrawerAnt>
    </DrawerContext.Provider>
  );
};
